"use client";

import { useSearchParams } from "next/navigation";
import { alvallalkozoJelentkezesBekuldese } from "@/lib/actions/alvallalkozok";

const SZOLGALTATASOK = [
  "Napelemes rendszer telepítés",
  "Karbantartás",
  "Tisztítás",
  "Szervizelés / hibaelhárítás",
  "Hőkamerás vizsgálat",
  "Villamos biztonsági felülvizsgálat",
];

export function AlvallalkozoiJelentkezesForm() {
  const params = useSearchParams();
  const siker = params.get("siker");
  const hiba = params.get("hiba");

  if (siker) {
    return (
      <div className="site-form">
        <p className="form-msg success">
          Köszönjük a jelentkezést! Munkatársunk hamarosan felveszi Önnel a kapcsolatot.
        </p>
      </div>
    );
  }

  return (
    <form action={alvallalkozoJelentkezesBekuldese} className="site-form cols-2" encType="multipart/form-data">
      {hiba && <p className="form-msg error">Kérjük, töltse ki a csillaggal jelölt kötelező mezőket.</p>}

      <div className="field span-2">
        <label>Cég neve *</label>
        <input name="cegnev" required />
      </div>
      <div className="field">
        <label>Székhely irányítószám *</label>
        <input name="szekhely_irsz" required />
      </div>
      <div className="field">
        <label>Székhely település *</label>
        <input name="szekhely_telepules" required />
      </div>
      <div className="field span-2">
        <label>Székhely közterület, házszám *</label>
        <input name="szekhely_kozterulet" required />
      </div>
      <div className="field span-2">
        <label>Működési hely (ha eltér a székhelytől)</label>
        <input name="mukodesi_hely" />
      </div>
      <div className="field">
        <label>Cégjegyzékszám *</label>
        <input name="cegjegyzekszam" required />
      </div>
      <div className="field">
        <label>Adószám *</label>
        <input name="adoszam" required />
      </div>
      <div className="field">
        <label>Képviselő neve *</label>
        <input name="kepviselo_nev" required />
      </div>
      <div className="field">
        <label>Képviselő beosztása</label>
        <input name="kepviselo_beosztas" />
      </div>
      <div className="field">
        <label>Kapcsolattartó neve *</label>
        <input name="kapcsolattarto_nev" required />
      </div>
      <div className="field">
        <label>Kapcsolattartó beosztása</label>
        <input name="kapcsolattarto_beosztas" />
      </div>
      <div className="field">
        <label>Kapcsolattartó telefon *</label>
        <input name="kapcsolattarto_telefon" type="tel" required />
      </div>
      <div className="field">
        <label>Kapcsolattartó e-mail *</label>
        <input name="kapcsolattarto_email" type="email" required />
      </div>
      <div className="field span-2">
        <label>Cég logó feltöltése</label>
        <input name="ceglogo" type="file" accept="image/*" />
      </div>
      <div className="field span-2">
        <label>Melyik szolgáltatást vállalja saját maga?</label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem" }}>
          {SZOLGALTATASOK.map((szolgaltatas) => (
            <label
              key={szolgaltatas}
              style={{ display: "flex", alignItems: "center", gap: "0.4rem", fontSize: "0.9rem" }}
            >
              <input type="checkbox" name="vallalhato_szolgaltatasok" value={szolgaltatas} style={{ width: 20, height: 20 }} />
              {szolgaltatas}
            </label>
          ))}
        </div>
      </div>
      <div className="field span-2">
        <button type="submit" className="btn btn-primary">
          Jelentkezés elküldése
        </button>
      </div>
    </form>
  );
}
